import { render } from "./Button.vue?vue&type=template&id=f3cf4f98&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=f3cf4f98&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Raska\\Desktop\\raska\\projekat\\astra\\astra-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3cf4f98"]])

export default __exports__